import React, { useRef } from 'react';
import { Stack, Text, Box } from '@tymate/margaret';
import { useIntersection } from 'react-use';
import styled, { css } from 'styled-components';
import IntersectionSensor from './IntersectionSensor';

export const GoalBox = styled(Stack).attrs({
  direction: 'column',
  alignX: 'center',
  gap: 1,
  padding: { default: 2, tablet: 3 },
})`
  position: relative;
  width: 36em;
  max-width: calc(100vw - ${({ theme }) => theme.spacing(2)});
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 20px;
  z-index: 2;
  margin-left: auto;
  margin-right: auto;
  transition: transform 1s ease;

  ${({ isVisible }) =>
    Boolean(isVisible) &&
    css`
      transform: translateY(-85%);

      ${({ theme }) => theme.media.tablet`
        transform: translateY(-100%);
      `};

      ${({ theme }) => theme.media.medium`
        transform: translateY(-100%);
      `};

      ${({ theme }) => theme.media.desktop`
        transform: translateY(-125%);
      `};
    `}
`;

const GoalSection = ({ data }) => {
  const intersectionRef = useRef();
  const goalBoxRef = useRef();
  const intersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 1,
  });

  return (
    <Box position="relative">
      <GoalBox isVisible={intersection?.isIntersecting} ref={goalBoxRef}>
        <IntersectionSensor section="#objectifs">
          <Text type="bodyLarge">{data?.goalsYearTitle}</Text>
          <Text paddingTop={2}>{data?.cloudCardDescription}</Text>
          <Stack direction="column" gap={1}>
            {(data?.steps || []).map(({ description, icon }, index) => (
              <Stack
                alignY="center"
                gap={{ default: 1, tablet: 2, desktop: 3 }}
                key={index}
              >
                <img src={icon?.url} alt="icon" style={{ width: 38 }} />
                <div>
                  <Text>{description}</Text>
                </div>
              </Stack>
            ))}
          </Stack>
        </IntersectionSensor>
      </GoalBox>

      <Box ref={intersectionRef} position="absolute" bottom="4em" />
    </Box>
  );
};

export default GoalSection;
